define('views/space_switcher/Podio.Views.SpaceSwitcherSearchResult',['require','jquery.scrollTo','lib/backbone/Backbone.PodioCollectionView','lib/Podio.UI','controllers/Podio.Controllers.DynamicContentManager','jquery','lib/Podio.Router.Content','views/space_switcher/Podio.Views.SpaceSwitcherSearchResultItem'],function(require) {

  require('jquery.scrollTo');

  var PodioCollectionView = require('lib/backbone/Backbone.PodioCollectionView');
  var podioUI = require('lib/Podio.UI');
  var keyCodes = podioUI.KeyCodes;
  var DynamicContentManager = require('controllers/Podio.Controllers.DynamicContentManager');
  var $ = require('jquery');
  var podioContentRouter = require('lib/Podio.Router.Content');

  return PodioCollectionView.extend({

    tagName: 'ul',

    podioEvents : {
      'click li'                   : 'onItemClicked',
      'click li .secondary-action' : 'onItemSecondaryActionClicked'
    },

    initialize: function() {
      this.itemView = require('views/space_switcher/Podio.Views.SpaceSwitcherSearchResultItem');
      this._super();
      this._bindToCollection();
    },

    render: function() {
      this.elm.appendTo( this.getOption('elmContainer') );
      this._super();
    },

    highlightItem: function(elmItem) {
      if (elmItem.length) {
        elmItem.addClass('active').focus();
        elmItem.siblings().removeClass('active');

        this.scrollToItem(elmItem);
      }
    },

    highlightSecondaryAction: function(elmTarget, toggle) {
      elmTarget.find('.secondary-action .icon-16').toggleClass('icon-16-tealplus', toggle);
      elmTarget.find('.secondary-action .icon-16').toggleClass('icon-16-green-plus-slim', !toggle);
    },

    highlightFirst: function() {
      this.highlightItem(this.elm.find('li:first'));
    },

    scrollToItem: function(elmItem) {

      var elmContainer = this.getOption('elmContainer');

      // Bounding box
      var offsetLimitTop = elmContainer.offset().top;
      var offsetLimitBottom = offsetLimitTop + elmContainer.outerHeight();

      var itemOffsetTop = elmItem.offset().top;
      var itemOffsetBottom = itemOffsetTop + elmItem.outerHeight();

      // Scrolling
      if ( (itemOffsetBottom > offsetLimitBottom) || (itemOffsetTop < offsetLimitTop) ) {
        elmContainer.scrollTo(elmItem);
      }
    },

    getActiveItemElm: function() {
      return this.elm.find('> .active');
    },

    onKeyUp: function(elmTarget, e) {
      if (e.keyCode === keyCodes.Shift) {
        var elmActiveItem = this.getActiveItemElm();

        this.highlightSecondaryAction(elmActiveItem, false);
      }
    },

    onKeyDown: function(elmTarget, e) {
      var elmActiveItem = this.getActiveItemElm();

      // ensure the caret in the textbox is not jumping around
      if (e.which === keyCodes.UpArrow || e.which === keyCodes.DownArrow) {
        e.preventDefault();
      }

      switch (e.keyCode) {
      case keyCodes.Shift:
        this.highlightSecondaryAction(elmActiveItem, true);

        break;
      case keyCodes.DownArrow:
      case keyCodes.UpArrow:
        this.highlightSecondaryAction(elmActiveItem, false);

        if (e.keyCode === keyCodes.DownArrow) {
          elmActiveItem = elmActiveItem.get(0) && elmActiveItem.get(0).nextSibling ? elmActiveItem.next() : this.elm.children().first();
        } else {
          elmActiveItem = elmActiveItem.get(0) && elmActiveItem.get(0).previousSibling ? elmActiveItem.prev() : this.elm.children().last();
        }

        if (elmActiveItem.length) {
          this.highlightItem(elmActiveItem);
        }

        return false;

      case keyCodes.Return:

        if ( elmActiveItem.length ) {
          e.stopPropagation();
          e.preventDefault();

          this.onItemClicked(elmActiveItem, e);
          return false;
        }

        break;
      }
    },

    handleSecondaryAction: function(url, e) {
      var contentManager = DynamicContentManager.getInstance();
      var navigateToContent = function() {
        podioContentRouter.navigate(url, { renderType: 'overlay' });
      }.bind(this);

      if (e && (e.metaKey || e.ctrlKey)) {
        window.open(url, '_blank');
      } else {
        if (contentManager.hasContent()) {
          if (contentManager.isOnPermalink()) {
            window.location = url;
          } else {
            contentManager.closeOverlay();
            navigateToContent();
          }
        } else {
          navigateToContent();
        }
      }

      // Hide space switcher
      this.trigger('spaceSwitcher:secondaryActionClicked');
    },

    onItemSecondaryActionClicked: function(elmTarget, e) {
      e.preventDefault();
      e.stopPropagation();
      var url = elmTarget.attr('href');
      this.handleSecondaryAction(url, e);
    },

    onItemClicked: function(elmTarget, e) {
      var url = elmTarget.find('.result-title a').attr('href');

      if (e && e.shiftKey && elmTarget.find('.secondary-action').length) {
        url = elmTarget.find('.secondary-action').attr('href');
        this.handleSecondaryAction(url, e);
      } else {
        if (e && (e.metaKey || e.ctrlKey)) {
          window.open(url, '_blank');
        }
        else {
          window.location = url;
        }
      }

    }

  });

});

